import { useMemo } from 'react';

/**
 * Returns a stable random index in [0, itemCount] suitable for injecting a
 * single item between existing list entries. The index is recomputed only
 * when `seed` or `itemCount` changes, so re-renders don't cause jumps.
 *
 * Returns -1 when there are no items to inject between.
 */
export function useRandomInsertionIndex(seed: string, itemCount: number): number {
  return useMemo(() => {
    if (itemCount <= 0) return -1;
    // Deterministic position per session: random on mount, stable afterwards
    return Math.floor(Math.random() * (itemCount + 1));
    // seed is part of deps so we regenerate when placement changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seed, itemCount]);
}
